import { useState } from 'react'

export function ExpandableDescription({ text }: any) {
    const maxLength = 20
    const [open,setOpen] = useState(false)
    return (
        <div className='text-neutral-400'>{open ? text : text.slice(0,maxLength)}{!open && <span>... <button className='underline text-blue-500 hover:text-blue-600' onClick={() => setOpen(!open)}>more</button></span>}</div>
    )
}